import { t } from '@/helper/i18n-utils';
import { computed } from 'vue';

export const links = [{
        title: computed(() => t('users.users')),
        href: "/admin/users",
        icon: "/images/admin/icons/user.svg",
        active_icon: "/images/admin/icons/user-white.svg",
        roles: ['ADMIN', 'Audit']
    },
    {
        title: computed(() => t('general.vacancies')),
        icon: "/images/admin/icons/vacancy.svg",
        active_icon: "/images/admin/icons/vacancy-white.svg",
        roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
        children: [{
                title: computed(() => t('vacancy.all_vacancies')),
                href: "/admin/vacancies/all",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('vacancy.add_vacancy')),
                href: "/admin/vacancies/add",
                roles: ['ADMIN', 'HR CC', 'HR DZO'],
            },
            {
                title: computed(() => t('vacancy.draft')),
                href: "/admin/vacancies/draft",
                roles: ['ADMIN', 'HR CC', 'Audit'],
            },
            {
                title: computed(() => t('vacancy.open')),
                href: "/admin/vacancies/open",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('vacancy.in_process')),
                href: "/admin/vacancies/in_process",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('vacancy.stop')),
                href: "/admin/vacancies/stop",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('vacancy.closed')),
                href: "/admin/vacancies/closed",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
        ]
    },
    {
        title: computed(() => t('resume.resume')),
        icon: "/images/admin/icons/resume.svg",
        active_icon: "/images/admin/icons/resume-white.svg",
        roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit', 'HR_COMMANDER'],
        children: [{
                title: computed(() => t('resume.all_resumes')),
                href: "/admin/resume/all",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.user_cc')),
                href: "/admin/resume/user_cc",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.user_dzo')),
                href: "/admin/resume/user_dzo",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.pmkr')),
                href: "/admin/resume/pmkr",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.mansap')),
                href: "/admin/resume/mansap",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.alyp')),
                href: "/admin/resume/alyp",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.commanders')),
                href: "/admin/resume/commanders",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit', 'HR_COMMANDER'],
            },
            {
                title: computed(() => t('resume.invalid')),
                href: "/admin/resume/invalid",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.user')),
                href: "/admin/resume/user",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.status_coordination')),
                href: "/admin/resume/coordination",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.passport_list')),
                href: "/admin/resume/passport",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
        ]
    },
    {
        title: computed(() => t('admin.content')),
        icon: "/images/admin/icons/content.svg",
        active_icon: "/images/admin/icons/content-white.svg",
        roles: ['ADMIN', 'ContentMaker'],
        children: [{
                title: computed(() => t('admin.pages')),
                href: "/admin/content/pages",
                roles: ['ADMIN', 'ContentMaker'],
            },
            // пока убрали 
            // {
            //     title: "Медиа",
            //     href: "/admin/content/media",
            // },
            // {
            //     title: "Видео",
            //     href: "/admin/content/video",
            // },
        ]
    },
    {
        title: computed(() => t('admin.directories')),
        icon: "/images/admin/icons/dictionary.svg",
        active_icon: "/images/admin/icons/dictionary-white.svg",
        roles: ['ADMIN', 'HR CC', 'HR DZO'],
        children: [{
                title: computed(() => t('admin.regions')),
                href: "/admin/directories/5001",
                roles: ['ADMIN'],
            },
            // пока не нужно
            // {
            //     title: computed(() => t('admin.company_activities')),
            //     href: "/admin/directories/5151",
            // },
            {
                title: computed(() => t('resume.education_degree')),
                href: "/admin/directories/5251",
                roles: ['ADMIN'],
            },
            {
                title: computed(() => t('resume.academic_degree')),
                href: "/admin/directories/5301",
                roles: ['ADMIN'],
            },
            {
                title: computed(() => t('resume.academic_title')),
                href: "/admin/directories/5351",
                roles: ['ADMIN'],
            },
            {
                title: computed(() => t('admin.work_skill')),
                href: "/admin/directories/5451",
                roles: ['ADMIN'],
            },
            {
                title: computed(() => t('fields.dzo')),
                href: "/admin/directories/6001",
                roles: ['ADMIN'],
            },
            {
                title: computed(() => t('fields.prof_area')),
                href: "/admin/directories/5501",
                roles: ['ADMIN', 'HR CC', 'HR DZO'],
            },
            {
                title: computed(() => t('admin.languages')),
                href: "/admin/directories/5401",
                roles: ['ADMIN'],
            },
            {
                title: computed(() => t('admin.work_place')),
                href: "/admin/directories/7001",
                roles: ['ADMIN'],
            },
            {
                title: computed(() => t('admin.certificates')),
                href: "/admin/directories/9001",
                roles: ['ADMIN'],
            },
            {
                title: computed(() => t('fields.employment')),
                href: "/admin/directories/9051",
                roles: ['ADMIN'],
            },
            {
                title: computed(() => t('resume.experience')),
                href: "/admin/directories/5551",
                roles: ['ADMIN', 'HR CC', 'HR DZO'],
            },
            // пока не нужно
            // {
            //     title: computed(() => t('admin.refuse_types')),
            //     href: "/admin/directories/10001",
            // }
        ]
    },
    {
        title: computed(() => t('admin.feedback')),
        icon: "/images/admin/icons/feedback.svg",
        active_icon: "/images/admin/icons/feedback-white.svg",
        roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit', 'Feedback', 'HR STUDENTS'],
        children: [{
                title: computed(() => t('admin.all_feedback')),
                href: "/admin/feedback",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit', 'Feedback'],
            },
            {
                title: computed(() => t('admin.students')),
                href: "/admin/students",
                roles: ['ADMIN', 'Audit', 'HR STUDENTS'],
            },
        ]
    },
    {
        title: computed(() => t('admin.tools')),
        icon: "/images/admin/icons/instruments.svg",
        active_icon: "/images/admin/icons/instruments-white.svg",
        roles: ['ADMIN', 'Audit'],
        children: [
            // {
            //     title: "Журнал изменений",
            //     href: "/admin/tools/updates",
            //     roles: ['ADMIN', 'Audit'],
            // },
            // {
            //     title: "Роли",
            //     href: "/admin/tools/roles",
            //     roles: ['ADMIN', 'Audit'],
            // },
            {
                title: computed(() => t('admin.messages')),
                href: "/admin/tools/mailings",
                roles: ['ADMIN'],
            },
        ]
    },
    // {
    //     title: "Настройки",
    //     icon: "/images/admin/icons/settings.svg",
    //     active_icon: "/images/admin/icons/settings-white.svg",
    //     roles: ['ADMIN', 'Audit'],
    //     children: [
    //         {
    //             title: "Настройка текстов",
    //             href: "/admin/settings/text",
    //             roles: ['ADMIN', 'Audit'],
    //         },
    //         {
    //             title: "Сообщения",
    //             href: "/admin/settings/messages",
    //             roles: ['ADMIN', 'Audit'],
    //         },
    //         {
    //             title: "Запросы",
    //             href: "/admin/settings/requests",
    //             roles: ['ADMIN', 'Audit'],
    //         },
    //         {
    //             title: "Типы журналов",
    //             href: "/admin/settings/types",
    //             roles: ['ADMIN', 'Audit'],
    //         },
    //     ]
    // },
    {
        title: computed(() => t('admin.reports')),
        icon: "/images/admin/icons/reports.svg",
        active_icon: "/images/admin/icons/reports-white.svg",
        roles: ['ADMIN', 'HR CC', 'HR DZO', 'HR STUDENTS', 'Audit'],
        children: [{
                title: computed(() => t('general.vacancies')),
                href: "/admin/report/vacancies",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('resume.resume')),
                href: "/admin/report/resume",
                roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            },
            {
                title: computed(() => t('reports.students')),
                href: "/admin/report/students",
                roles: ['ADMIN', 'HR STUDENTS', 'Audit'],
            },
            // {
            //     title: "Выгрузка",
            //     href: "/admin/report/unloading",
            //     roles: ['ADMIN', 'HR CC', 'HR DZO', 'Audit'],
            // },
        ]
    },
    // {
    //     title: "Подписки",
    //     href: "/admin/subscribes",
    //     icon: "/images/admin/icons/subscribes.svg",
    //     active_icon: "/images/admin/icons/subscribes-white.svg",
    //     roles: ['ADMIN', 'Audit']
    // },
    {
        title: computed(() => t('admin.logs')),
        href: "/admin/logs",
        icon: "/images/admin/icons/logs.svg",
        active_icon: "/images/admin/icons/logs-white.svg",
        roles: ['ADMIN']
    },
];

export const directories = [{
        code: '5201',
        title_code: 'fields.specializations'
    },
    {
        code: '6001',
        title_code: 'fields.dzo',
        child: '6051'
    },
    {
        code: '5501',
        title_code: 'fields.prof_area',
        child: '5201'
    },
    {
        code: '5401',
        title_code: 'admin.languages',
    },
    {
        code: "5001",
        title_code: 'admin.regions',
        child: '5051'
    },
    {
        code: "5151",
        title_code: 'admin.company_activities',
    },
    {
        code: "5251",
        title_code: 'resume.education_degree',
    },
    {
        code: "5301",
        title_code: 'resume.academic_degree',
    },
    {
        code: "5351",
        title_code: 'resume.academic_title',
    },
    {
        code: "5451",
        title_code: 'admin.work_skill',
    },
    {
        code: "7001",
        title_code: 'admin.work_place',
    },
    {
        code: "9001",
        title_code: 'admin.certificates',
    },
    {
        code: "9051",
        title_code: 'fields.employment',
    },
    {
        code: "10001",
        title_code: 'admin.refuse_types',
    },
    {
        code: "5051",
        title_code: 'admin.cities',
    },
    {
        code: '6051',
        title_code: 'admin.departments',
    },
    {
        code: '5551',
        title_code: 'resume.experience',
    },
];

export const userCodes = {
    user: 'USER',
    user_cc: 'USER CC',
    user_dzo: 'USER DZO'
};